import { render, staticRenderFns } from "./SupplierBuyerElement.vue?vue&type=template&id=55c1c713"
import script from "./SupplierBuyerElement.vue?vue&type=script&lang=js"
export * from "./SupplierBuyerElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports